import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import Toasted from 'vue-toasted'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import store from '@/store'
import router from '@/router'
import Api from '@/lib/api'
import isRole from '@/utils/roleCheck'
import userProvider from '@/utils/userProvider'
import i18n from '@/lang'
import Pusher from '@/lib/pusher'
import VueClipboard from 'vue-clipboard2'
import './sass/main.scss'
import moment from 'moment'
import VueGtag from 'vue-gtag'
import { datadogRum } from '@datadog/browser-rum'

Vue.use(Api)
Vue.use(isRole)
Vue.use(userProvider)
Vue.use(VueClipboard)
Vue.use(Toasted, { position: 'top-center', keepOnHover: true })
Vue.use(Pusher)
Vue.use(VueGtag, {
  config: {
    id: 'G-BB51PLZL7M'
  }
}, router)

moment.locale('es')
Vue.prototype.$moment = moment

Vue.filter('initial', function (value) {
  return (!value) ? '' : value[0].toUpperCase()
})

Vue.filter('toFix2', function (value) {
  return (!value && isNaN(Number(value))) ? '' : Number(value).toFixed(2)
})

Vue.filter('toFixNumber', function (value, decimal = 2) {
  return (!value && isNaN(Number(value))) ? '' : Number(value).toFixed(decimal)
})

Vue.filter('numberWithComma', function (value) {
  if (!value && isNaN(Number(value))) {
    return ''
  }
  const num = value.toString().split('.')
  const valWithCommas = num[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return (valWithCommas && num[1]) ? valWithCommas.concat('.', num[1]) : valWithCommas
})

Vue.filter('percentOf', function (value, total) {
  return ((!value && isNaN(Number(value))) && (!total && isNaN(Number(total))))
    ? ''
    : (value * 100) / total
})

Vue.filter('prefix', function (value, prefix) {
  if (!value && isNaN(Number(value))) return ''
  if (value < 0) {
    return `-${prefix}${value * -1}`
  }
  return `${prefix}${value}`
})

Vue.filter('sufix', function (value, sufix) {
  if (!value && isNaN(Number(value))) return ''
  return `${value}${sufix}`
})

Vue.filter('toDate', function (val) {
  if (!val) return ''
  return moment(val).locale('es').format('DD-MMM-YYYY')
})

Vue.filter('toDateTime', function (val) {
  if (!val) return ''
  return moment(val).locale('es').format('MMM DD, YYYY HH:mm')
})

Vue.filter('abs', function (value) {
  return (!value && isNaN(Number(value))) ? 0 : Math.abs(Number(value))
})

Vue.filter('truncateText', function (text, maxLength) {
  if (!text || !maxLength) return ''
  if (text.length <= maxLength) {
    return text
  } else {
    return text.slice(0, maxLength) + '...'
  }
})

Vue.config.productionTip = false

Vue.prototype.$isMobile = window.innerWidth < 960

window.addEventListener('resize', function () {
  Vue.prototype.$isMobile = this.innerWidth < 960
})

datadogRum.init({
  applicationId: '91cfd0d3-65cf-45b4-8b87-66905d4b59dd',
  clientToken: 'pub4e1ce405daed3899f9ed4130b980a400',
  site: 'datadoghq.com',
  service: 'eato',
  env: 'production',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 10,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'allow'
})

datadogRum.startSessionReplayRecording()

new Vue({
  i18n,
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
